import apiService from 'services/api'
import { Tag } from 'models/tags'
import BaseSelectModal, {
  BaseSelectModalProps,
} from './BaseSelectModal/BaseSelectModal'
import { bulkEditSingleParams } from 'services/apiTypes'

export default function SalesStageSelectModal({
  tableObjAccessor = 'sales_stage',
  useReportsEndpoint = false,
  ...props
}: {
  tableObjAccessor?: string
  useReportsEndpoint?: boolean
} & Omit<
  BaseSelectModalProps<Tag>,
  | 'apiAction'
  | 'title'
  | 'subtitle'
  | 'label'
  | 'placeholder'
  | 'onConfirmAddNew'
  | 'items'
  | 'tableObjAccessor'
>) {
  const api = apiService()
  const { data: salesStages } = api.useGetSalesStageOptions(true)

  const apiAction = async (params: bulkEditSingleParams) => {
    const { item_id: sales_stage, ...rest } = params
    // Use report-specific endpoint when called from deal reports table
    return useReportsEndpoint
      ? api.bulkEditDealReports({
          deal: { sales_stage_id: sales_stage },
          ...rest,
        })
      : api.bulkEditDeal({
          deal: { sales_stage_id: sales_stage },
          ...rest,
        })
  }

  if (!salesStages) return null

  return (
    <BaseSelectModal
      {...props}
      title="Change Sales Stage"
      subtitle={
        <span>
          Add or replace the sales stage for <b>all</b> selected rows.
        </span>
      }
      label="Sales Stage"
      placeholder="Select Sales Stage"
      items={salesStages}
      tableObjAccessor={tableObjAccessor!}
      apiAction={apiAction}
    />
  )
}
